

(function () {
  'use strict';

  angular
    .module('main.nav', [])

    .directive('headerMenu', function () {
      var directive = {
        restrict: 'A',

        /* @ngInject */
        controller: ["$rootScope", "$window", "$cookies", "$element", "DateService", function ($rootScope, $window, $cookies, $element, DateService) {

          var ctrl = this;
          var lang = {
            frBeta: { url: 'http://testoonbeta.ow04.fr/' },
            enBeta: { url: 'http://testoonbeta-en.ow04.fr/' },
            frPreProd: { url: 'http://testoonbeta-multi.ow04.fr/' },
            enPreProd: { url: 'http://testoonbeta-multien.ow04.fr/' },
            fr: { url: 'https://www.testoon.com/', value: 'FR' },
            en: { url: 'https://en.testoon.com/', value: 'EN' }
          };

          function setCookiesSwitch() {
            setTimeout(function () {
              $cookies.put('cookieSwitch', ctrl.checked, {
                path: '/',
                expires: DateService.nextYear()
              });
            });
          }

          function getDefaultUrl() {
            switch (ctrl.language) {
              case lang.en.value:
                if ($window.location.href.indexOf(lang.frBeta.url) < 0 &&
                  $window.location.href.indexOf(lang.enBeta.url) < 0) {
                  if ($window.location.href.indexOf(lang.frPreProd.url) >= 0 ||
                    $window.location.href.indexOf(lang.enPreProd.url) >= 0) {
                    return lang.enPreProd.url;
                  }

                  return lang.en.url;
                }

                return lang.enBeta.url;
              default:
                if ($window.location.href.indexOf(lang.frBeta.url) < 0 && $window.location.href.indexOf(lang.enBeta.url) < 0) {
                  if ($window.location.href.indexOf(lang.frPreProd.url) >= 0 ||
                    $window.location.href.indexOf(lang.enPreProd.url) >= 0) {
                    return lang.frPreProd.url;
                  }

                  return lang.fr.url;
                }

                return lang.frBeta.url;
            }
          }

          function getDefaultLanguage() {
            if ($window.location.href.indexOf(lang.enBeta.url) >= 0
              || $window.location.href.indexOf(lang.enPreProd.url) >= 0
              || $window.location.href.indexOf(lang.en.url) >= 0) {
              return lang.en.value;
            }
            return lang.fr.value;
          }

          ctrl.$onInit = function () {
            ctrl.setMenuActive = function () {
              $rootScope.$broadcast('setMenuActive');
              ctrl.isMenuActive = !ctrl.isMenuActive;
            };

            var cookieSwitch = $cookies.get('cookieSwitch');
            ctrl.checked = !angular.isUndefined(cookieSwitch) ? cookieSwitch : true;
            if (ctrl.checked == 'false') ctrl.checked = false
            else ctrl.checked = true

            var cookieLanguage = $cookies.get('language');
            ctrl.language = !angular.isUndefined(cookieLanguage) ? cookieLanguage : getDefaultLanguage();
            refreshSelects();
          };

          // ng-class="mainNavCtrl.isMenuActive ? 'menuActive' : '' "
          // headerMenuCtrl.setMenuActive()

          ctrl.setLanguage = function () {
            $window.location.href = getDefaultUrl();
          };

          ctrl.setSwitch = function () {
            setCookiesSwitch();
          };

          function refreshSelects() {
            setTimeout(function () {
              $element.find('select.refresh').each(function (index, el) {
                $(el).selectpicker('refresh');
              });
            });
          }
        }],
        controllerAs: 'headerMenuCtrl'
      };

      return directive;
    })

    .directive('mainNav', function () {
      var directive = {
        restrict: 'A',
        bindToController: {
          navMenuContext: '@',
          navMenuMetier: '@',
          dataColor: '<',
          device: '<'
        },
        controllerAs: 'mainNavCtrl',
        scope: true,

        /* @ngInject */
        controller: ["$scope", "HttpService", function ($scope, HttpService) {
          var ctrl = this;

          ctrl.$onInit = function () {

            ctrl.setIsScroll = true;


            // OUVRIR LE MENU PAR DEFAUT SUR le 1er noeud qui checkbox1 a true
            /* if (ctrl.checkbox) {
              $event.preventDefault();
            }*/

            // ON RECUPERE LA DEVICE TOUCH/NOTOUCH
            if (ctrl.device.size === 'xl' || ctrl.device.size === 'lg' || ctrl.device.size === 'md') {
              ctrl.isDeviceTouch = false;
              // console.log('TOUCH FALSE' + ctrl.isDeviceTouch);
            } else {
              ctrl.isDeviceTouch = true;
              // console.log('TOUCH TRUE');
            }

            // ON RECUPERE LA COULEUR DU NOEUD
            getColor();

            if (ctrl.device.size === 'xl' || ctrl.device.size === 'lg' || ctrl.device.size === 'md') {

              // gestion du scroll actif/inactif

              // ctrl.setIsScroll = function () {
              //    $rootScope.$broadcast('setIsScroll');
              //    //ctrl.isMenuActive = !ctrl.isMenuActive;
              //    console.log('setIsScroll' + setIsScroll);
              // };
              // ctrl.isMenuScrollActive = false;

              if (ctrl.navMenuContext === 'Product') {
                ctrl.isMenuProductActive = true;
                ctrl.menuProductActiveClass = 'hidden';
              } else {
                ctrl.isMenuProductActive = false;
                ctrl.menuProductActiveClass = '';
              }


              if (ctrl.navMenuMetier === 'Metier') {

                ctrl.isMenuMetierActive = true;
                ctrl.menuMetierActiveClass = 'hidden';

              } else if (ctrl.navMenuMetier === 'Shop') {

                ctrl.isMenuShopActive = true;
                ctrl.menuShopActiveClass = 'hidden';

              } else {
                ctrl.isMenuMetierActive = false;
                ctrl.menuMetierActiveClass = '';
                ctrl.isMenuShopActive = false;
                ctrl.menuShopActiveClass = '';

              }

            }

            getTestoonContext();

          };

          $scope.$on('setMenuActive', function () {
            ctrl.isMenuActive = !ctrl.isMenuActive;

          });

          $scope.$on('setMenuBackActive', function () {
            ctrl.isMenuBackActive = !ctrl.isMenuBackActive;
          });

          $scope.$on('logUpdate', function () {
            getTestoonContext();
          });

          $scope.$on('delogUpdate', function () {
            // console.info('logout');
            getTestoonContext();
          });

          $scope.$on('logoutFromMenu', function () {
            // console.info('logout');
            getTestoonContext();
          });

          function getTestoonContext() {
            HttpService.get({
              url: '/GetTestoonContext',
              cache: false
            })
              .then(function (response) {

                ctrl.HasAccessPrivateShop = response.HasAccessPrivateShop ? 1 : 0;
                ctrl.HasAccessPrivateSale = response.HasAccessPrivateSale ? 1 : 0;
                ctrl.KeyCatalogue = response.KeyCatalogue;

              });
          }

          function getColor() {
            var items = $('#breadcrumb').children(),
              len = $('#breadcrumb').children().length - 1;

            while (len > 1) {
              var $item = $(items[len]);
              ctrl.menuColor = $item.data('color');
              len--;
            }
          }
        }]
      };

      return directive;
    })

    .directive('liMain', function () {

      return {

        restrict: 'A',
        bindToController: {
          idCategory: '<',
          hasParent: '<',
          checkbox: '<',
          device: '<',
          hasSons: '<'
        },
        scope: true,
        controllerAs: 'liNavCtrl',

        /* @ngInject */
        controller: ["$element", function ($element) {

          var ctrl = this;

          // cibler menu via idCategory => custom class active
          // cibler menu parent via dataParent => cibler le retour en mode mobile
          // menu coche1 ou hover, soit ascenceur ou colonnage

          ctrl.$onInit = function () {

             
            // declarer besoin à l'initialisation du DOM
            // OUVRIR LE MENU PAR DEFAUT SUR le 1er noeud qui checkbox1 a true
            if (ctrl.checkbox) {
              ctrl.liClass = 'activeClick';
            } else {
              ctrl.liClass = 'activeHover';
            }

            initMenu();
          };

          ctrl.liClass = '';

          ctrl.menuQuit = function () {

            if (ctrl.device.size === 'xxs' || ctrl.device.size === 'xs' || ctrl.device.size === 'sm') {
              var classe = ctrl.liClass === 'itemActive' ? ' ' : 'itemActive';
              updateClass(classe);
            }

          };

          ctrl.menuClick = function () {

            if (ctrl.device.size === 'lg' || ctrl.device.size === 'md') {

              if (!ctrl.checkbox) return;

            }

            if (ctrl.device.size === 'xxs' || ctrl.device.size === 'xs' || ctrl.device.size === 'sm') {

              var classe = ctrl.liClass === 'itemActiveIn' ? 'itemActiveOut' : 'itemActiveIn';
              // console.log('classe' + classe);
              updateClass(classe);

            }
          };

          ctrl.menuBackClick = function () {

            if (ctrl.device.size === 'lg' || ctrl.device.size === 'md') {
              if (!ctrl.checkbox) return;
            }

            if (ctrl.device.size === 'xxs' || ctrl.device.size === 'xs' || ctrl.device.size === 'sm') {
              // var classe = ctrl.liClass === 'itemActiveIn' ? 'itemActiveOut' : 'itemActiveIn';
              // console.log('classe' + classe );
              removeClass();
            }
          };

          ctrl.preventDefault = function ($event) {

            if (ctrl.checkbox) {
              $event.preventDefault();
            }

            if (ctrl.device.size === 'xxs' ||
              ctrl.device.size === 'xs' ||
              ctrl.device.size === 'sm' ||
              ctrl.checkbox === 'true') {

              $event.preventDefault();
            }
          };

          function initMenu() {
            if (ctrl.device.size === 'xxs' || ctrl.device.size === 'xs' || ctrl.device.size === 'sm') return;

            hoverintent($element[0],
              function () {
                updateClassMenu();
                // console.log('updateClass');
                // scope.expandMenu();
              },
              function () {
                removeClassMenu();
                // console.log('removeClass');
                // scope.reduceMenu();
              })
              .options(
                {
                  timeout: 500,
                  interval: 200
                }
              );
          }

          function updateClassMenu() {
            var $menu = $element.children('.ulLevel1');

            $menu.addClass('in');

          }

          function removeClassMenu() {
            var $menu = $element.children('.ulLevel1');

            $menu.removeClass('in');

          }

          function updateClass(categoryClass) {

            ctrl.liClassActive = categoryClass;
            ctrl.isBackActive = true;
            // $timeout(function () {
            //    ctrl.liClassActive = categoryClass;
            // }, 800);

          }

          function removeClass(categoryClass) {

            ctrl.liClassActive = categoryClass;
            ctrl.isBackActive = false;
            // $timeout(function () {
            //    ctrl.liClassActive = categoryClass;
            // }, 800);

          }

        }]

      };

    });

})();

